module.exports = __webpack_public_path__ + "static/ArboriaMedium-e8c28ecc13bdeca316b283077d1cc678.ttf";